import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d74582a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Отправить ")

import { PropType, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { submitReport } from '@/features/FSubmitReport/api/submit.api'
import { showErrorMessage } from '@/shared/utils'
import { ReportViewType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  reportType: String as PropType<ReportViewType>,
  reportId: Number,
  sendCommentFiles: Boolean,
  enabled: Boolean,
},
  setup(__props) {

const props = __props



const loading = ref(false)

const handleSubmitReportToEmail = async (): Promise<void> => {
  loading.value = true

  const [error] = await submitReport(
    props.reportType,
    props.reportId,
    props.sendCommentFiles
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчёт отправлен на почту',
      type: 'success',
    })
  }

  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    class: "submit-report",
    disabled: !props.enabled,
    loading: loading.value,
    type: "primary",
    round: "",
    onClick: handleSubmitReportToEmail
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["disabled", "loading"]))
}
}

})